<template>
  <div
    class="movies-video-area"
    :style="{ backgroundImage: `url(${backgroundImage})` }"
  >
    <div class="container-fluid">
      <div class="row justify-content-center align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="movies-video-content">
            <span class="sub">الأعلى تقييماً اليوم</span>
            <h1>سيرفر loay iptv فائق الثبات</h1>
            <p>
              استمتع بأقوى تجربة مشاهدة بدون تقطيع. نوفر لك الوصول الفوري لأكثر من 10,000 قناة مباشرة بجودة 4K و FHD، بالإضافة إلى أضخم مكتبة أفلام ومسلسلات مترجمة ومحدثة يومياً تناسب كافة أجهزة العائلة.
              <RouterLink to="/services-details">اقرأ المزيد</RouterLink>
            </p>
            <ul class="btn-list">
              <li>
                <a href="https://wa.me/447429916178" target="_blank" class="btn">
                  <span class="border-style">اشترك الآن</span>
                </a>
              </li>
              <li>
                <a href="https://wa.me/447429916178" target="_blank" class="btn">
                  <span class="border-style">طلب تجربة مجانية</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="movies-video-btn">
            <lightgallery :settings="{ speed: 500, plugins }">
              <a
                href="https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30"
                class="video-btn"
              >
                <i class="ri-play-fill"></i>
              </a>
            </lightgallery>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Lightgallery from "lightgallery/vue";
import lgVideo from "lightgallery/plugins/video";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css";

export default defineComponent({
  name: "TopRatedToday",
  components: {
    Lightgallery,
  },
  setup() {
    const plugins = ref([lgVideo]);
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const backgroundImage = require("@/assets/images/movie-home/video-bg.jpg");

    return {
      plugins,
      backgroundImage,
    };
  },
});
</script>